export default {
  sections: {
    wonoloer: {
      header: 'Profile',
      wonoloingSince: 'Wonoloing since %startDate%',
      welcome: 'Please welcome %firstName% with an awesome first time experience at %customerName%!',
      info: {
        favoritesByCompanies: 'Favorites by Companies',
        totalWonoloJobs: 'Total Wonolo Jobs',
        jobsForCustomer: 'Jobs at %customerName%'
      }
    },
    verification: {
      header: 'Verifications',
      verifications: {
        background: 'Criminal Background Check',
        occupational: 'Occupational Accident Insurance',
        liability: 'General Liability Insurance'
      }
    },
    experience: {
      header: 'Experience Wonoloing'
    },
    sidebar: {
      headers: {
        contact: 'CONTACT',
        actions: 'ACTIONS'
      },
      actions: {
        offerLongTerm: 'Create a job offer',
        longTermOffered: 'Job offer created',
        hire: 'Report as new hire',
        hired: 'Hired',
        favorite: 'Favorite',
        favorited: 'Favorited',
        teams: 'Teams',
        block: 'Block',
        unblock: 'Unblock',
        autoApprove: 'Auto-Approve Jobs',
        autoApproveEnabled: 'Auto-Approve Enabled'
      },
    },
    autoApproveModal: {
      header: 'Auto-Approve Jobs',
      content: {
        enabled: "%workerName%'s jobs will be automatically approved within 15 minutes of the job being completed.",
        disabled: "You will manually approve %workerName%'s jobs"
      }
    },
    hireWonoloerModal: {
      title: 'Report as New Hire',
      description: "We're excited that you've found a Wonoloer who is a great fit for your team!\n\nOnce we receive your request, you can expect to receive an e-mail confirmation with the Direct Hire Fee in the next 30 days. This fee is based on the hours %firstName% worked.\n\nIf you wouldn't mind, we'd love if you could tell us why %firstName% is a great fit so that we can continue to improve the quality of our worker pool.",
      form: {
        notes: {
          placeholder: 'Let us know why it’s a good fit...'
        },
        optional: 'Optional',
        buttons: {
          cancel: 'Cancel',
          submit: 'Send request'
        }
      }
    },
    longTermJobModal: {
      title: 'Create a job through Wonolo',
      disclaimer: 'We cannot guarantee that %firstName% will accept this job.',
      description: 'Choose the job and dates you need so that we can create and offer this job to:',
      form: {
        title: 'Job',
        totalWorkdays: 'Total Workdays: %numberOfWorkdays%',
        buttons: {
          cancel: 'Cancel',
          submit: 'Create job'
        },
        shiftSchedulePreview: {
          startDate: {
            label: 'Next available start date',
            tooltip: 'You can only pick a date that’s available after all their upcoming jobs with you are completed.'
          },
        }
      },
      successMessage: "We've sent %firstName% a job offer for %templateName%.",
    },
    badges: {
      header: 'Badges at Wonolo'
    },
    recentJobs: {
      header: 'Recent Jobs at %customerName%',
      description: '*Only jobs in which you are the Job Owner are being displayed.',
      table: {
        cells: {
          workerStatusState: {
            flexible_filled: 'Filled Flexible',
            filled: 'Scheduled',
            in_progress: 'Clocked In',
            paused: 'Paused',
            no_show: 'No Show',
            withdrawn: 'Withdrawn',
            cancelled: 'Cancelled',
            invited: 'Invited',
            rejected: 'Rejected',
            completed: 'Completed',
            approved: 'Approved',
          }
        }
      }
    },
    customerStats: {
      header: 'Contributions to %customerName%',
      permissionWarning: 'Data may be limited based on your user permissions.',
      info: {
        totalJobs: 'Total Jobs',
        totalHours: 'Total Hours',
        daysSinceLastJob: 'Days Since Last Job',
      }
    }
  }
};
